"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = void 0;
const splitTitle_1 = __importDefault(require("@opsbase/lib-general/utils/splitTitle"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const CloseIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CloseIcon"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const Chip_1 = __importDefault(require("../Chip"));
const makeMyClasses = (color, textWidth) => ({
    label: {
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        height: 24,
        width: 'fit-content',
        padding: '0 12px 0 12px',
        margin: 2,
        marginRight: 0,
        borderRadius: 12,
        backgroundColor: color ? color.main : lib_palette_1.default.secondary.main,
        color: `${color ? color.contrastText : lib_palette_1.default.secondary.contrastText} !important`,
    },
    textLabel: {
        maxWidth: textWidth ? textWidth : 200,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    preLabel: {
        lineHeight: '10px',
        fontSize: 10,
        color: lib_palette_1.default.GreyBlue.main,
    },
});
function Pill(props) {
    const { label, avatar, value, opacity = 1, noBorder = false, small = false, backgroundColor = lib_palette_1.default.WhiteSmoke, deleteIcon, color, textWidth } = props, otherProps = __rest(props, ["label", "avatar", "value", "opacity", "noBorder", "small", "backgroundColor", "deleteIcon", "color", "textWidth"]);
    const { title, preTitle } = (0, splitTitle_1.default)(value);
    const myCss = (0, web_css_1.default)(makeMyClasses, [color, textWidth]);
    return (0, react_1.useMemo)(() => {
        const icon = !avatar && label ? (react_1.default.createElement(Text_1.default, { variant: "tiny", className: myCss.label }, label)) : undefined;
        const labelBit = (react_1.default.createElement(Text_1.default, { className: myCss.textLabel, variant: small ? 'small' : 'body' },
            title,
            !!preTitle && react_1.default.createElement("div", { className: myCss.preLabel }, preTitle)));
        return (react_1.default.createElement(Chip_1.default, Object.assign({}, otherProps, { color: backgroundColor, border: noBorder ? undefined : lib_palette_1.default.Platinum, opacity: opacity, icon: icon, small: small, label: labelBit, avatar: avatar, textTransform: 'none', deleteIcon: deleteIcon || react_1.default.createElement(CloseIcon_1.default, { size: 14 }) })));
    }, [
        avatar,
        backgroundColor,
        deleteIcon,
        label,
        myCss.label,
        myCss.preLabel,
        myCss.textLabel,
        noBorder,
        opacity,
        otherProps,
        preTitle,
        small,
        title,
    ]);
}
exports.Pill = Pill;
exports.default = Pill;
